export const setGatePasses = (state, payload) => {
  state.gatePasses = payload
}
export const setGatePass = (state, payload) => {
  state.gatePass = payload
}
